import React from "react"
import Layout from "../components/Layout"
import { graphql, useStaticQuery } from "gatsby"
import Title from "../components/Title"
import Image from "gatsby-image"

  export const query = graphql`
{
    allStrapiAbout {
            nodes {
                stack {
                    id
                    title
                }
                title
                info
                image {
                    childImageSharp {
                        fluid {
                           ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
     }
`

const About = ({data}) => {
     const {allStrapiAbout: {nodes}} = data
    const {title, stack, info, image} = nodes[0]
  return (
      <Layout>
        <section className="about-page">
          <div className="section-center about-center">
            <Image fluid={image.childImageSharp.fluid} className="about-img"/>
            <article className="about-text">
              <Title title={title}/>
              <p>{info}</p>
              <div className="about-stack">
                {stack.map((item)=>{
                  return <span key={item.id}>{item.title}</span>
                })}
              </div>
            </article>
          </div>
        </section>
      </Layout>
  )
}

export default About
